'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { find, get, isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import Logger from '../../../utils/Logger';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import OTButton from '../../tag/OTButton';
import Loader from '../../Loader';
import Alert from '../../Alert';
import {
  hideQueueReservationModal,
  requestQueueReservationOptionsFailed,
  showQueueReservationModal,
  getAvailableSlots,
  selectQueueReservationOption,
  doReserveAppointment,
} from '../../../data/appointment/actions';
import { connect } from 'react-redux';
import InvalidArgumentError from '../../../api/InvalidArgumentError';
import { APPOINTMENTS } from '../../../data/reducer';
import ToastHOC from '../../ToastHOC';
import Calendar from '../ReservationCalendar/Calendar';
import { formatCustom } from '../../../utils/TimeUtils';
import OTButtonGroup from '../../tag/OTButtonGroup';
import {
  mapReservationTimesForCalendar,
  mapSelectedAppointmentForCalendar,
} from '../../../utils/AppointmentUtils';

import AppointmentModal from '../modal/AppointmentModal';
import AppointmentLocation from '../modal/AppointmentLocation';
import AppointmentTime from '../modal/AppointmentTime';
import NoReservableAppointmentsNotification from './NoReservableAppointmentsNotification';

const { id: module_id } = module;
const logger = new Logger(module_id);

class AppointmentFromQueue extends React.Component {
  constructor() {
    super();
    this.state = {
      showCalendar: false,
    };
  }

  componentWillReceiveProps = (newProps) => {
    let { data } = newProps;
    if (data) {
      this.setState({
        showCalendar: true,
      });
    }
  };

  componentWillMount() {
    let { dispatch } = this.props,
      //verify appointment id form
      appointmentId = get(this.props, 'match.params.appointmentId', null);

    if (!appointmentId || !Number.isInteger(Number.parseInt(appointmentId))) {
      dispatch(
        requestQueueReservationOptionsFailed(
          new InvalidArgumentError({
            code: 'INVALID_APPOINTMENT_ID',
            msg: 'Appointment id is invalid: must be a number',
          })
        )
      );
      return;
    }

    dispatch(getAvailableSlots(appointmentId));
  }

  submit = () => {
    let { data, dispatch } = this.props;

    let item = data.filter((item) => item.selected)[0];

    if (item.selected) {
      logger.debug('submit item: ', item);
      dispatch(showQueueReservationModal());
    } else {
      logger.debug('submit - no operation');
    }
  };

  confirmTime = (selectedSlot, appointmentData) => {
    let { data, dispatch, history } = this.props;

    let item = data.filter((item) => item.selected);

    if (!(item instanceof Array) || item.length !== 1) {
      throw new Error('ambiguous selection');
    }

    const reserveDto = {
      schedule: selectedSlot.scheduleId,
      serviceType: appointmentData.serviceType,
      location: appointmentData.locationId,
      dateStart: selectedSlot.dateStart,
      dateEnd: selectedSlot.dateEnd,
      supportingInformation: appointmentData.appointmentId,
    };

    dispatch(doReserveAppointment(reserveDto, history));
  };

  closeModal = () => {
    let { dispatch } = this.props;
    dispatch(hideQueueReservationModal());
  };

  cancel = () => {
    this.props.history.push(`/appointments`);
  };

  selectTime = (item) => {
    let { dispatch } = this.props;
    dispatch(selectQueueReservationOption(item.dateStart));
  };

  render() {
    let {
      isFetching,
      showModal,
      data,
      error,
      isReserving,
      toasts,
      appointmentData,
    } = this.props;

    let info = null,
      selectedSlot = null,
      hasReservationOptions = !isFetching && !error && !isEmpty(data),
      showCalendar = null;

    if (isFetching) {
      info = <Loader />;
    }

    if (error) {
      info = <Alert message={`${module_id}.${error.code}`} />;
    } else if (!isFetching) {
      if (!isEmpty(data.filter((item) => !item.original))) {
        hasReservationOptions = !isFetching && !error && !isEmpty(data);
        selectedSlot = find(data, (item) => item.selected, null);
        showCalendar = this.state.showCalendar;
      }
    }

    return (
      <div className="ot-mainview">
        <Row>
          <Span>
            <h1 className="ot-viewtitle">
              <FormattedMessage id={`${module_id}.title`} />
            </h1>
          </Span>
        </Row>
        {(toasts || info) && (
          <Row>
            <Span>
              {toasts.map((item) => (
                <Alert {...item.spec} />
              ))}
              {info}
            </Span>
          </Row>
        )}
        {
          <Row>
            <Span>
              <h2 className="inline-label uppercase">
                <FormattedMessage id={`${module_id}.select.time`} />
              </h2>
            </Span>
          </Row>
        }
        {showCalendar && (
          <Calendar
            selectTime={this.selectTime}
            selectedTime={
              selectedSlot && mapSelectedAppointmentForCalendar(selectedSlot)
            }
            data={mapReservationTimesForCalendar(data)}
          />
        )}
        {hasReservationOptions ? (
          <Row>
            <OTButtonGroup type={'big'} fullWidth collapseOnMobile>
              <OTButton onClick={this.cancel} color={'gray'} message={'back'} />
              {
                <OTButton
                  disabled={!selectedSlot || selectedSlot.original}
                  onClick={this.submit}
                >
                  <FormattedMessage id={'reserve.appointment'} />
                  {selectedSlot && !selectedSlot.original && (
                    <span className={'screen-reader-only'}>
                      {formatCustom(
                        selectedSlot.dateStart,
                        'DD.MM.YYYY [klo] HH:mm - '
                      ) + formatCustom(selectedSlot.dateEnd, 'HH:mm')}
                    </span>
                  )}
                </OTButton>
              }
            </OTButtonGroup>
          </Row>
        ) : (
          !isFetching && (
            <NoReservableAppointmentsNotification
              clinic={''}
              history={this.props.history}
            />
          )
        )}

        {hasReservationOptions && selectedSlot && (
          <AppointmentModal
            modalIsOpen={showModal}
            isFetching={isReserving}
            closeModal={this.closeModal}
            confirmTime={() => this.confirmTime(selectedSlot, appointmentData)}
          >
            <AppointmentLocation location={appointmentData.location} />
            <AppointmentTime
              selectedTime={{
                dateStart: selectedSlot.dateStart,
                dateEnd: selectedSlot.dateEnd,
              }}
            />
          </AppointmentModal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let {
    isFetching,
    lastFetch,
    isReserving,
    showModal,
    error,
    data,
    appointmentData,
  } = state[APPOINTMENTS].availableSlots;

  return {
    isFetching,
    lastFetch,
    isReserving,
    showModal,
    error,
    data,
    appointmentData,
  };
};

const toastOptions = {
  module_id: module_id,
  dismissOnUnmount: ['QUEUE_APPOINTMENT_FAILED_TOAST'],
};

export default withRouter(
  connect(mapStateToProps)(ToastHOC(toastOptions, AppointmentFromQueue))
);
